<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="visible"
      title="正在计算"
      center
      width="600px"
      destroy-on-close
      :auto-upload="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from '@/config/config'

let Timer = null
let PostTimer = null

export default {
  data() {
    return {
      URL_PATH: URL_PATH,
      visible: false,
      title: '',
      percentage: 0,
      fileName: ''
    }
  },
  methods: {
    show(data) {
      if (data) {
        this.fileName = data
        this.percentage = 0
        clearInterval(Timer)
        clearInterval(PostTimer)
        Timer = null
        PostTimer = null
        this.runTimer()
        this.visible = true
      }
    },
    runTimer() {
      let _this = this
      Timer = setInterval(function() {
        _this.percentage += 1
        if (_this.percentage >= 100) {
          _this.close()
          _this.$emit('complete', 'show')
        }
      }, 100)

      PostTimer = setInterval(function() {
        _this.getProcess()
      }, 2000)
    },
    getProcess() {
      this.$api.getProcess({
        file: this.fileName
      }).then(({ data }) => {
        if (data.file) {
          this.close()
          this.$emit('complete', data.file)
        }
      })
    },
    close() {
      this.percentage = 100
      clearInterval(Timer)
      clearInterval(PostTimer)
      Timer = null
      PostTimer = null
      this.visible = false
    }
  },
  created() {
    this.$root.$on('showProgress', this.show)
  }
}
</script>
<style lang="less" scoped>
.upload-wrap {
  text-align: center;
}

.tips {
  font-size: 16px;
  line-height: 1;
  text-align: center;
  color: #000000;
  margin-bottom: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/progressDialog.vue